import { render } from "./GibergMWatches.vue?vue&type=template&id=bb672006&scoped=true"
import script from "./GibergMWatches.vue?vue&type=script&lang=js"
export * from "./GibergMWatches.vue?vue&type=script&lang=js"

import "./GibergMWatches.vue?vue&type=style&index=0&id=bb672006&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb672006"]])

export default __exports__